export default "__VITE_ASSET__DG9L_lIz__"